'use strict';

module.exports = /* @ngInject */ function() {

	function format(stringDate, parseFormat = null, format = 'DD.MM.YYYY') {
		const date = parseFormat ? window.moment(stringDate, parseFormat) : window.moment(stringDate);
		return date.format(format);
	}

	return format;
}
